import View from './view';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../../redux/selectors/runtime/theme';
import {contentSelector} from '../../../../redux/selectors/resources';
export const LoginHeader = ({safeArea = true}: {safeArea?: boolean}) => {
  const visuallyImpairedSettings = useSelector(themeSelector());
  const content = useSelector(contentSelector());
  return View({
    visuallyImpairedSettings,
    content,
    safeArea,
  });
};
